import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero is-small is-primary" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "title is-uppercase" }
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { class: "section px-3" }
const _hoisted_6 = { class: "container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1)
const _hoisted_8 = { class: "footer" }
const _hoisted_9 = { class: "level" }
const _hoisted_10 = { class: "level-item" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "level-right" }
const _hoisted_13 = { class: "level-item" }
const _hoisted_14 = { class: "level-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminView = _resolveComponent("AdminView")!
  const _component_UserView = _resolveComponent("UserView")!
  const _component_TouchButton = _resolveComponent("TouchButton")!
  const _component_AdminButton = _resolveComponent("AdminButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.store.site_config.title), 1),
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.store.site_config.subtitle), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_ctx.store.is_admin)
          ? (_openBlock(), _createBlock(_component_AdminView, { key: 0 }))
          : (_openBlock(), _createBlock(_component_UserView, { key: 1 }))
      ])
    ]),
    _hoisted_7,
    _createElementVNode("footer", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", {
            innerHTML: _ctx.store.site_config.footer
          }, null, 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_TouchButton, { class: "tag is-warning" })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_AdminButton, { class: "tag is-link is-outlined" })
          ])
        ])
      ])
    ])
  ], 64))
}